import { Component, OnInit, AfterViewInit, OnDestroy, Input } from '@angular/core';
import { EFormControl } from '../../../../../shared-components/e-forms/e-form-control.model';
import * as _ from 'lodash';
import { Lookup } from '../../../../../shared-components/lookup/lookup.model';
import { Subscription } from 'rxjs';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { EFormService } from '../../../../../shared-components/e-forms/e-form.service';
import { EFormDesignerService } from '../../e-form-designer.service';
import { EFormConfiguration, enmEFormViewModes } from '../../../e-form-config.model';
import { CustomFieldControlTypeEnum } from '../../../../../shared-modules/customization-framework/models/custom-data-control-type.model';
import { LoginService } from '../../../../../shared-modules/login/login.service';

@AutoUnsubscribe({ includeArrays: true })
@Component({
  selector: 'e-form-available-controls',
  templateUrl: './e-form-available-controls.component.html',
  styleUrls: ['./e-form-available-controls.component.css']
})
export class EFormAvailableControlsComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() config = new EFormConfiguration();
  // controlPalette: EFormControl[] = [];
  inputControls: EFormControl[] = [];
  nonInputControls: EFormControl[] = [];
  defaultOptions: Lookup[] = [];
  connectedDropLists: string[] = [];
  subscriptions: Subscription[] = [];
  readOnly = false;
  customFields = false;
  constructor(
    private eFormDesignerService: EFormDesignerService,
    private eFormService: EFormService,
    private loginService: LoginService
  ) { }

  ngOnInit() {
    if (this.config) {
      if (this.config.ReadOnly) {
        this.readOnly = this.config.ReadOnly;
      }
      if (this.config.CustomFieldsFlag) {
        this.customFields = this.config.CustomFieldsFlag;
      }
    }

    this.generatePalette();
    this.eFormDesignerService.connectedDropListAdd('controlPalette');
    this.eFormDesignerService.connectedDropListAdd('controlPaletteInput');
    this.connectedDropLists = this.eFormDesignerService.connectedDropLists;
    this.subscriptions.push(this.eFormDesignerService.observableConnectedDropListsStream$.subscribe((list) => {
      this.connectedDropLists = list;
    }));
  }

  generatePalette() {
    let control = new EFormControl();

    // attachment
    if (!this.config.IsSurvey && this.config.AllowAttachmentControls) {
      control.ControlType = this.eFormService.controlTypes.attachment;
      control.LinkedDBField = -1;
      this.populateCustomFieldProperties(control);
      this.inputControls.push(_.cloneDeep(control));
    }

    // buttons
    control = new EFormControl();
    control.ControlType = this.eFormService.controlTypes.buttons;
    control.Width = '94px';
    control.LinkedDBField = -1;
    this.populateCustomFieldProperties(control);
    this.inputControls.push(_.cloneDeep(control));

    // checkbox
    control = new EFormControl();
    control.ControlType = this.eFormService.controlTypes.checkbox;
    control.LinkedDBField = -1;
    this.populateCustomFieldProperties(control);
    this.inputControls.push(_.cloneDeep(control));

    // checkbox with textbox
    // control = new EFormControl();
    // control.ControlType = this.eFormService.controlTypes.checkboxWithTextbox;
    // control.LinkedDBField = -1;
    // this.populateCustomFieldProperties(control);
    // this.inputControls.push(_.cloneDeep(control));

    // datepicker
    control = new EFormControl();
    control.ControlType = this.eFormService.controlTypes.date;
    control.LinkedDBField = -1;
    if (this.config.AllowShowTodayButton) {
      control.Width = '196px';
    }
    else {
      control.Width = '148px';
    }
    this.populateCustomFieldProperties(control);
    this.inputControls.push(_.cloneDeep(control));

    // timepicker
    control = new EFormControl();
    control.ControlType = this.eFormService.controlTypes.time;
    control.LinkedDBField = -1;
    control.Width = '196px';
    this.populateCustomFieldProperties(control);
    this.inputControls.push(_.cloneDeep(control));

    // divider
    control = new EFormControl();
    control.ControlType = this.eFormService.controlTypes.divider;
    control.Width = '100%';
    control.RemoveBottomPadding = true;
    this.nonInputControls.push(_.cloneDeep(control));

    // vertical divider
    if (this.config.ViewMode == enmEFormViewModes.Page) {
      control = new EFormControl();
      control.ControlType = this.eFormService.controlTypes.verticalDivider;
      control.RemoveBottomPadding = true;
      control.Height = '100%';
      this.nonInputControls.push(_.cloneDeep(control));
    }

    // dropdown
    control = new EFormControl();
    control.ControlType = this.eFormService.controlTypes.dropdown;
    control.LinkedDBField = -1;
    control.Width = '196px';
    this.populateCustomFieldProperties(control);
    this.inputControls.push(_.cloneDeep(control));

    // image
    control = new EFormControl();
    control.ControlType = this.eFormService.controlTypes.image;
    control.Width = '94px';
    this.nonInputControls.push(_.cloneDeep(control));

    // link to file
    control = new EFormControl();
    control.ControlType = this.eFormService.controlTypes.linkToFile;
    control.LinkedDBField = -1;
    this.nonInputControls.push(_.cloneDeep(control));

    // note field
    control = new EFormControl();
    control.ControlType = this.eFormService.controlTypes.note;
    control.Width = '196px';
    control.NoteRows = 3;
    control.LinkedDBField = -1;
    this.populateCustomFieldProperties(control);
    this.inputControls.push(_.cloneDeep(control));

    // radio buttons
    control = new EFormControl();
    control.ControlType = this.eFormService.controlTypes.radioButtons;
    control.Width = '94px';
    control.LinkedDBField = -1;
    this.populateCustomFieldProperties(control);
    this.inputControls.push(_.cloneDeep(control));

    // text
    control = new EFormControl();
    control.ControlType = this.eFormService.controlTypes.text;
    control.Value = '';
    this.nonInputControls.push(_.cloneDeep(control));

    // text box
    control = new EFormControl();
    control.ControlType = this.eFormService.controlTypes.textbox;
    control.LinkedDBField = -1;
    control.Width = '196px';
    this.populateCustomFieldProperties(control);
    this.inputControls.push(_.cloneDeep(control));

    if ((this.customFields || this.config.ViewMode == enmEFormViewModes.FRMA) && this.loginService.LoginSettings.CustomizationDevMode) {
      // custom component
      control = new EFormControl();
      control.ControlType = this.eFormService.controlTypes.component;
      control.LinkedDBField = -1;
      control.Width = '196px';
      this.populateCustomFieldProperties(control);
      this.inputControls.push(_.cloneDeep(control));
    }
  }

  populateCustomFieldProperties(control: EFormControl) {
    if (this.customFields) {
      control.CustomField = true;
      control.CustomFieldName = '';
      control.CustomFieldRefName = '';
      control.CustomFieldAllowControlToHandleOwnData = this.config.CSTFieldsManageOwnData;
      if (this.loginService.LoginSettings.CustomizationDevMode && this.config.ViewMode == enmEFormViewModes.Page) {
        control.CannotBeRemoved = true;
      }
      else {
        control.CannotBeRemoved = false;
      }
      control.CustomFieldControlTypeID = this.eFormDesignerService.convertEFormControlTypeToCustomFieldTypeID(control.ControlType);
    }
  }

  dragStart() {
    this.eFormDesignerService.dragStart();
  }

  dragEnd() {
    this.eFormDesignerService.dragEnd();
  }

  enterPredicate() {
    return false;
  }

  ngAfterViewInit() { }

  ngOnDestroy() { }

}
